

    (function($){
      if  (window.innerWidth < 768){

        let carousel_section = $('.section.s7');
        let lightSliderLoaded = false;
        const isRTL = languageAttributes.languageCode === 'ar';
        const sliderBreakpoints = [
            {
                breakpoint: 950,
                item: 3,
                slideMove: 2,
                slideMargin: 6
            },
            {
                breakpoint: 768,
                item: 1,
                slideMove: 1,
                slideMargin: 10
            },
        ];
    
        function doScrolling() {
            if (carousel_section.length > 0 && !lightSliderLoaded && typeof window.isInViewport != 'undefined' && window.isInViewport(carousel_section)) {
                import('../slider/slider').then((module) => {
                    const Slider = module.default; // or module.Slider if it's a named export
                    new Slider(sliderBreakpoints, isRTL);
                    lightSliderLoaded = true;
            });

            }
        }

        window.scrollingTasks.push(doScrolling);
    }

    })(window.jQuery);




